import * as React from 'react'
import { Link } from 'react-router-dom'
import * as classNames from 'classnames'
import EntityTabBarItem from '../ui/entity/EntityTabBarItem'
import EntityTabBar from '../ui/entity/EntityTabBar'

const Selector = (props: { redirectTo: string; location: string; title: string }) => {
  const isActive = props.location === props.redirectTo
  return (
    <Link to={props.redirectTo}>
      <EntityTabBarItem active={isActive}>{props.title}</EntityTabBarItem>
    </Link>
  )
}

const DriverViewNavigationTabs = (props: { path: string; location: string }) => {
  return (
    <EntityTabBar>
      <Selector redirectTo={`${props.path}/details`} title={'personal info'} location={props.location} />
      <Selector redirectTo={`${props.path}/products`} title={'products'} location={props.location} />
      <Selector
        redirectTo={`${props.path}/session-history-old`}
        title={'Session history (Old)'}
        location={props.location}
      />
      <Selector redirectTo={`${props.path}/session-history`} title={'Session history'} location={props.location} />
      <Selector redirectTo={`${props.path}/schedule`} title={'Schedule'} location={props.location} />
      <Selector redirectTo={`${props.path}/location`} title={'Location'} location={props.location} />
    </EntityTabBar>
  )
}

export default DriverViewNavigationTabs



// WEBPACK FOOTER //
// ./src/components/drivers/DriverViewNavigationTabs.tsx